export const menuAreaClienteSelect = ({ menuAreaClienteSelect }) => menuAreaClienteSelect;

export const loadingAction = ({ loadingAction }) => loadingAction;
